module.exports = __webpack_public_path__ + "media/images/document/file-932e89cf70c418a2ec22ac7949c86a6e.svg";